/* Calm Supplements landing page (sections/calmy-supp-*.liquid).

   Purchase section [data-csup-buy]: variant selection from the product's own
   variant data, gallery, quantity, add to cart and the phone sticky bar.
   FAQ [data-csup-faq]: one open question per FAQ.

   The add goes through the same path as the product page (calmy-pdp.js): the
   whole form as FormData, posted with fetch to /cart/add.js (the bundles app
   intercepts fetch, and its fields travel in the form), then the theme's own
   Calmy.refreshCart(true) to update and open the cart. One submit listener per
   form; the sticky button is a submit button OF that form, so a tap on either
   runs the same single handler, and a busy flag stops double adds.

   Loaded by more than one section, so it guards itself; each element is set up
   once, and the theme editor's section reloads are picked up. */
(function () {
  if (window.__calmySupp) return;
  window.__calmySupp = true;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ── Gallery ─────────────────────────────────────────────────────────── */
  function initGallery(g) {
    var slides = $$(g, '[data-csup-slide], .csup-gal__slide');
    var thumbs = $$(g, '[data-csup-thumb]');
    var count = $(g, '[data-csup-count]');
    if (slides.length < 2) return { show: function () {} };
    var cur = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        var im = s.querySelector('img');
        if (on && im && im.loading === 'lazy') im.loading = 'eager';
      });
      thumbs.forEach(function (t, k) { if (k === cur) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
    }
    function showMedia(id) {
      var k = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); });
      if (k > -1) show(k);
    }
    var prev = $(g, '[data-csup-prev]'), next = $(g, '[data-csup-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });

    /* Horizontal swipe on the main image; vertical movement is left to the
       page so scrolling is never captured. */
    var main = $(g, '[data-csup-main], .csup-gal__main'), x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });
    show(cur);
    return { show: show, showMedia: showMedia };
  }

  /* ── Purchase section ────────────────────────────────────────────────── */
  function initBuy(sec) {
    if (sec.__csup) return;
    sec.__csup = true;
    var form = $(sec, 'form[data-csup-form]');
    if (!form) return;
    var data = [];
    try { data = JSON.parse($(sec, '[data-csup-variants]').textContent); } catch (e) {}
    var idInput = $(form, '[data-csup-id]');
    var btns = $$(sec, 'button[data-csup-atc]');
    var err = $(sec, '[data-csup-err]');
    var gal = sec.querySelector('[data-csup-gallery]') ? initGallery($(sec, '[data-csup-gallery]')) : null;
    var fieldsets = $$(form, '[data-csup-opt]');
    var qtyInput = $(form, '[data-csup-qty-input]');
    var busy = false;
    var current = data.find(function (v) { return String(v.id) === idInput.value; }) || data[0];

    function selected() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function setLabel(b, key) {
      /* Two-line buttons keep their second line: only the label span changes. */
      var t = b.querySelector('[data-csup-label]') || b;
      t.textContent = b.getAttribute('data-label-' + key) || t.textContent;
    }
    function paint() {
      var v = current;
      /* Tell the offer's shipping / stock row (calmy-lp.js) which variant is shown. */
      sec.dispatchEvent(new CustomEvent('csup:variant', { bubbles: true, detail: { variant: v } }));
      var ok = !!(v && v.available);
      btns.forEach(function (b) { b.disabled = !ok; setLabel(b, v ? (ok ? 'add' : 'out') : 'out'); });
      if (!v) return;
      idInput.value = v.id;
      var now = $(sec, '[data-csup-now]'), was = $(sec, '[data-csup-was]'), sp = $(sec, '[data-csup-stick-price]');
      if (now) now.textContent = v.price;
      if (sp) sp.textContent = v.price;
      if (was) { if (v.compare) { was.textContent = v.compare; was.hidden = false; } else { was.textContent = ''; was.hidden = true; } }
      var st = $(sec, '[data-csup-stock]'), stt = $(sec, '[data-csup-stock-t]');
      if (st) st.classList.toggle('is-out', !ok);
      if (stt) stt.textContent = stt.getAttribute(ok ? 'data-in' : 'data-out') || stt.textContent;
      if (gal && v.media) gal.showMedia(v.media);
      /* Mark values that cannot make an available variant with the others. */
      var sel = selected();
      fieldsets.forEach(function (fs, oi) {
        var legendV = fs.querySelector('[data-csup-optv]');
        if (legendV) legendV.textContent = sel[oi] || '';
        $$(fs, 'input').forEach(function (inp) {
          var trial = sel.slice(); trial[oi] = inp.value;
          var any = data.some(function (x) { return x.available && x.options.every(function (o, k) { return o === trial[k]; }); });
          inp.classList.toggle('is-unavailable', !any);
        });
      });
    }
    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () {
        var sel = selected();
        current = data.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); }) || null;
        if (err) err.textContent = '';
        paint();
      });
    });

    $$(form, '[data-csup-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-csup-qty'), 10);
        qtyInput.value = Math.max(1, n);
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!current || !current.available) { paint(); return; }
      busy = true;
      if (err) err.textContent = '';
      btns.forEach(function (b) { b.disabled = true; setLabel(b, 'busy'); });
      var payload = new FormData(form);
      payload.set('id', String(current.id));
      payload.set('quantity', String(qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1));
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: payload })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          busy = false;
          paint();
          if (!res.ok) {
            if (err) err.textContent = res.body.description || res.body.message || 'This item could not be added to the cart.';
            return;
          }
          if (window.Calmy && window.Calmy.refreshCart) window.Calmy.refreshCart(true);
          else window.location.href = '/cart';
        })
        .catch(function () {
          busy = false;
          paint();
          if (err) err.textContent = 'Network error. Please try again.';
        });
    });
    paint();
    initSticky(sec);
  }

  /* Sticky bar: phones only (CSS). Shown once the first section of the page
     has scrolled away and while the purchase section is still below; hidden
     whenever the purchase section, the footer or a cookie banner is on
     screen, so it never sits over the real button or the footer's controls.
     While shown, the page gets bottom padding equal to the bar so no content
     is left underneath it. */
  function initSticky(sec) {
    var bar = $(sec, '[data-csup-stick]');
    var first = document.querySelector('.csup, .csr, .lp');
    if (!bar || !first || !('IntersectionObserver' in window)) return;
    var pastFirst = false, secIn = false, secAbove = false, tailIn = false;
    var phone = window.matchMedia(bar.classList.contains('csr-stick') ? '(max-width: 749px)' : '(max-width: 899px)');
    function cookieOpen() {
      var c = document.getElementById('shopify-pc__banner');
      return !!(c && c.offsetParent !== null && c.getBoundingClientRect().height > 0);
    }
    function sync() {
      var on = phone.matches && pastFirst && !secIn && !secAbove && !tailIn && !cookieOpen();
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.style.paddingBottom = on ? bar.offsetHeight + 'px' : '';
    }
    new IntersectionObserver(function (es) { es.forEach(function (en) { pastFirst = !en.isIntersecting && en.boundingClientRect.top < 0; }); sync(); }).observe(first === sec ? sec : first);
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { secIn = en.isIntersecting; secAbove = !en.isIntersecting && en.boundingClientRect.top < 0; });
      sync();
    }).observe(sec);
    var tails = document.querySelectorAll('footer, .cfoot, .cfootref, .cnl');
    if (tails.length) {
      var seen = new Set();
      var to = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
        tailIn = seen.size > 0; sync();
      });
      tails.forEach(function (t) { to.observe(t); });
    }
    if (phone.addEventListener) phone.addEventListener('change', sync);
    /* The cookie banner has no event of its own; re-check after any tap. */
    document.addEventListener('click', function () { setTimeout(sync, 400); }, true);
  }

  /* ── FAQ: one open question per list ─────────────────────────────────── */
  function initFaq(list) {
    if (list.__csup) return;
    list.__csup = true;
    var items = $$(list, 'details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  }

  function scan(root) {
    $$(root || document, '[data-csup-buy]').forEach(initBuy);
    $$(root || document, '[data-csup-faq]').forEach(initFaq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
